import { dashboardApi } from './http';

export async function getVersion() {
  const response = await dashboardApi.get('/dashboard/v1/version');
  return response.data;
}
